module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sincere thanks to the staff of the Tampa Theatre, especially Jill Witecki, John Bell and former staff member Tara Schroeder; to all the many students and former students of the University of Tampa who have shared their stories with me over the years; to the Tampa History Center Research Library, especially David and Phyllis; to Paul Guzzo, for his information and inspiration regarding Charlie Wall; to Michelle, Derek, Jensen and Forest of Duckweed Urban Market; to the staff of the Hotel Floridan, especially April, Daniel, Costa and, of course, Tony at the piano; to Lynn Brown, for believing in me; to Donna and Steve Bremer, who first helped me to become a writer; to Tim Reeser, for allowing me to tell ghost stories on the streets of Tampa; and most of all to Craig, for photographic and technical support, holding my hand or kicking my rear as needed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a01f1ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/acknowledgement.vue
// module id = 69
// module chunks = 0